/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Notice_TermsInputs */

const en_seller_notice_terms = /** @type {(inputs: Seller_Notice_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms`)
};

const pl_seller_notice_terms = /** @type {(inputs: Seller_Notice_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regulamin`)
};

/**
* | output |
* | --- |
* | "Terms" |
*
* @param {Seller_Notice_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seller_notice_terms = /** @type {((inputs?: Seller_Notice_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Notice_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seller_notice_terms(inputs)
	return en_seller_notice_terms(inputs)
});